'use strict'

import 'lazysizes'
import 'picturefill'
import 'picturefill/dist/plugins/intrinsic-dimension/pf.intrinsic.min.js'

import { mounted } from '@utilities'

const animateFadeUp = async () => {
  try {
    const items = document.querySelectorAll('.js-fadeUp')

    if (!items.length) {
      return
    }

    const { animateFadeUp } = await import(
      /* webpackChunkName: "animateFadeUp" */ '@modules/animateFadeUp'
    )

    animateFadeUp(items)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

const animateFadeIn = async () => {
  try {
    const items = document.querySelectorAll('.js-fadeIn')

    if (!items.length) {
      return
    }

    const { animateFadeIn } = await import(
      /* webpackChunkName: "animateFadeIn" */ '@modules/animateFadeIn'
    )

    animateFadeIn(items)
  } catch (error) {
    /* eslint no-console: 0 */
    console.log(error)
  }
}

mounted(() => {
  animateFadeUp()
  animateFadeIn()
})
